import { takeLatest, call, put } from 'redux-saga/effects';
import { showApplicationFormStart } from './actions';
import { loading, success, failure } from './slice';
import { getApplicationForm } from './service';
import { setApplicationForm } from '../slice';
import { Action } from '@reduxjs/toolkit';

function* showApplicationFormFlow(action: Action<unknown>) {
  if (showApplicationFormStart.match(action)) {
    try {
      yield put(loading());
      const { data } = yield call(getApplicationForm, action.payload);
      const { data: applicationForm } = data;
      yield put(setApplicationForm(applicationForm));
      yield put(success());
    } catch (error) {
      const { message }: { message: string } = error?.response?.data || error;
      const statusCode: number = error?.response?.status;
      yield put(failure({ message, statusCode }));
    }
  }
}

export default function* onShowApplicationFormStart() {
  yield takeLatest(showApplicationFormStart, showApplicationFormFlow);
}
